/**
 * 公共组件 UploadFile
 */
export default {
  dbl_upload_click: "Click to Upload",
  dbl_upload_drag: "/Drag to this Area",
  dbl_upload_info: "Supports single txt and CSV formats, do not add column names for CSV format.",
  dbl_upload_invalid: "The file size does not conform to the specification. Please upload a txt file with the size less than 60M",
  dbl_upload_size: "File size:",
  dbl_upload_date: "Upload date:",
  dbl_upload_cancel: "Cancel",
  dbl_upload_reupload: "Re-upload",
  dbl_upload_delete: "Delete",
  dbl_upload_release_mouse: "Release Mouse"
};